"use client";

import { useEffect, useRef, useState } from "react";

export default function KdbOddsAndBookmaker({
  extendValue,
  bookmakerValue,
  extendOptions,
  bookmakerOptions,
  onExtendChange,
  onBookmakerChange,
  extendPlaceholder = "TL Malaysia",
  bookmakerPlaceholder = "Vin88",
}) {
  const [oddsOpen, setOddsOpen] = useState(false);
  const [bookmakerOpen, setBookmakerOpen] = useState(false);
  const oddsRef = useRef(null);
  const bookRef = useRef(null);

  const selectedExtend = extendOptions.find(
    (o) => String(o.value) === String(extendValue),
  );
  const selectedBookmaker = bookmakerOptions.find(
    (o) => String(o.value) === String(bookmakerValue),
  );
  const formatExtendLabel = (label) =>
    String(label || "").replace(/^Tỷ lệ\s+/i, "TL ");

  useEffect(() => {
    const close = (e) => {
      const t = e.target;
      if (oddsRef.current?.contains(t) || bookRef.current?.contains(t)) return;
      setOddsOpen(false);
      setBookmakerOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const openOdds = () => {
    setBookmakerOpen(false);
    setOddsOpen((v) => !v);
  };

  const openBook = () => {
    setOddsOpen(false);
    setBookmakerOpen((v) => !v);
  };

  return (
    <div className="flex w-full min-w-0 shrink-0 flex-col gap-2 md:w-auto md:flex-row md:items-stretch">
      <div className="relative min-w-0 w-full shrink-0 md:w-auto md:min-w-[150px]" ref={oddsRef}>
        <button
          type="button"
          onClick={openOdds}
          className="flex h-[36px] w-full min-w-[150px] cursor-pointer items-center justify-between rounded-[4px] border border-solid border-[var(--theme-primary)] bg-[var(--theme-primary)] px-[12px] text-[14px] text-white"
        >
          <span className="truncate">
            {selectedExtend
              ? formatExtendLabel(selectedExtend.label)
              : formatExtendLabel(extendPlaceholder)}
          </span>
          <svg
            className={`h-[12px] w-[12px] text-white transition-transform ${
              oddsOpen ? "rotate-180" : ""
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>

        {oddsOpen && (
          <div className="absolute left-0 top-full z-[999] mt-[4px] w-full overflow-hidden rounded-[4px] border border-solid kdb-dropdown-border bg-white py-[4px] shadow-lg">
            {extendOptions.map((item) => {
              const active = String(item.value) === String(extendValue);
              return (
                <button
                  key={item.value}
                  type="button"
                  className={`block w-full cursor-pointer rounded-none border-0 px-[12px] py-[8px] text-left text-[14px] transition-colors ${
                    active
                      ? "kdb-bg-odds-hover font-medium text-[var(--theme-text)]"
                      : "bg-white text-[var(--theme-text)] hover:kdb-bg-odds-hover"
                  }`}
                  style={{ borderRadius: 0, border: "none" }}
                  onClick={() => {
                    onExtendChange(item.value);
                    setOddsOpen(false);
                  }}
                >
                  {formatExtendLabel(item.label)}
                </button>
              );
            })}
          </div>
        )}
      </div>

      <div className="relative min-w-0 w-full shrink-0 md:w-auto md:min-w-[150px]" ref={bookRef}>
        <button
          type="button"
          onClick={openBook}
          className="group flex h-[36px] w-full min-w-[150px] cursor-pointer items-center justify-between rounded-[4px] border border-solid kdb-dropdown-border bg-white px-[12px] text-[14px] text-[var(--theme-text)] transition-all hover:border-[var(--theme-primary)]"
        >
          <span className="truncate">
            {selectedBookmaker ? selectedBookmaker.label : bookmakerPlaceholder}
          </span>
          <svg
            className={`h-[12px] w-[12px] text-[var(--theme-text-muted)] transition-all group-hover:text-[var(--theme-primary)] ${
              bookmakerOpen ? "rotate-180 text-[var(--theme-primary)]" : ""
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>

        {bookmakerOpen && (
          <div className="absolute right-0 top-full z-[999] mt-[4px] w-full overflow-hidden rounded-[4px] border border-solid kdb-dropdown-border bg-white py-[4px] shadow-lg md:w-[150px]">
            {bookmakerOptions.map((item) => {
              const active = String(item.value) === String(bookmakerValue);
              return (
                <button
                  key={item.value}
                  type="button"
                  className={`block w-full cursor-pointer rounded-none border-0 px-[12px] py-[8px] text-left text-[14px] transition-colors ${
                    active
                      ? "kdb-bg-odds-hover font-medium text-[var(--theme-text)]"
                      : "bg-white text-[var(--theme-text)] hover:kdb-bg-odds-hover"
                  }`}
                  style={{ borderRadius: 0, border: "none" }}
                  onClick={() => {
                    onBookmakerChange(item.value);
                    setBookmakerOpen(false);
                  }}
                >
                  {item.label}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
